import ApiClient from './ApiClient';

const base = ({ accountId, conversationId }) =>
  `/api/v1/accounts/${accountId}/conversations/${conversationId}/scheduled_messages`;

export default {
  // GET /api/v1/accounts/:account_id/conversations/:conversation_id/scheduled_messages
  get({ accountId, conversationId }) {
    return axios.get(base({ accountId, conversationId }));
  },

  // POST /api/v1/accounts/:account_id/conversations/:conversation_id/scheduled_messages
  create({ accountId, conversationId, scheduled_message }) {
    return axios.post(base({ accountId, conversationId }), { scheduled_message });
  },

  // PATCH /api/v1/accounts/:account_id/conversations/:conversation_id/scheduled_messages/:id
  update({ accountId, conversationId, id, scheduled_message }) {
    return axios.patch(`${base({ accountId, conversationId })}/${id}`, {
      scheduled_message,
    });
  },

  // DELETE /api/v1/accounts/:account_id/conversations/:conversation_id/scheduled_messages/:id
  delete({ accountId, conversationId, id }) {
    return axios.delete(`${base({ accountId, conversationId })}/${id}`);
  },
};
